import { ReactNode, useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'

interface IProps {
  children: ReactNode
}

export function CustomDatadogProvider({ children }: IProps) {
  useEffect(() => {
    if (
      import.meta.env.VITE_DATADOG_CLIENT_TOKEN &&
      import.meta.env.VITE_DATADOG_APPLICATION_ID
    ) {
      datadogRum.init({
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'dws-pwa',
        env: import.meta.env.VITE_ENV_NAME?.toLowerCase(),
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
      })
    }
  }, [])

  return <>{children}</>
}
